import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/UserWelcomeIntro.css";
import NavBar from '../NavBar';
import CalculatorSleep from './Components/CalculatorPages/CalculatorSleep';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function CalculatorSleepRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileHeartAgeRoutePage">
                    <div className="UserProfileHeartAgeRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="CalculatorSleepRouteBlock">
                        <CalculatorSleep/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default CalculatorSleepRoute;